<template>
  <footer class="footer bxbb" :class="isFixed ? 'footer_fixed' : ''">
    <div
      :class="orgData.footer_nav.length !== 0 ? 'h100' : ''"
      v-if="$specialOrg()"
    >
      <div class="container df ai-c jc-c">
        <!-- <a href="javascript:;" class="logo">
        <img src="../assets/image/logo.png" alt />
      </a> -->
        <div class="footWrap">
          <div class="footerNav" v-if="orgData.footer_nav.length">
            <div
              class="fnavItem"
              v-for="(item, ind) in orgData.footer_nav"
              :key="ind"
            >
              <a v-if="item.href" :href="compHref(item.href)" target="_blank">{{
                item.title
              }}</a>
              <span v-else>{{ item.title }}</span>
            </div>
          </div>
          <div
            class="footer_main"
            :class="orgData.footer_nav.length ? '' : 'info'"
          >
            <p class="copyright" v-if="website.copyright_info">
              Copyright © {{ website.copyright_info }}
            </p>
            <p class="copyright" v-else>
              Copyright © 广州冠岳网络科技有限公司 粤ICP备09217733号
            </p>
            <div class="fb_btn ta3" @click="openFeedback">意见反馈</div>
            <a
              href="https://goyor-yihuiai.feishu.cn/docx/Ax4Cd2x1IoODe2x3GlEcMm5xnRg"
              target="_blank"
              class="fb_btn ta3"
            >
              使用指南
            </a>
          </div>
          <div class="supor" v-if="identity_type == 1">
            <!-- <a href="javascript:;" class="logo">
              <img src="../assets/image/logo.png" alt />
            </a>
            冠岳网络科技提供技术支持 -->
            <div class="btn">
              <span @click="toManageAdmin">管理后台</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="feedbackVisible"
      :before-close="feedbackClose"
      class="fb_dialog"
    >
      <el-form :model="feedbackForm" ref="fbRef" :rules="rules">
        <el-form-item>
          <div class="form_title">反馈类型</div>
          <div class="fb_type">
            <div
              class="fb_type_item ta3"
              :class="{ active: e.id == feedbackForm.type }"
              v-for="e in feedbackType"
              :key="e.id"
              @click="selectFeedbackType(e.id)"
            >
              {{ e.name }}
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="contents">
          <div class="form_title">反馈内容</div>
          <el-input
            v-model.trim="feedbackForm.contents"
            type="textarea"
            :rows="4"
            resize="none"
            placeholder="请输入反馈内容"
          ></el-input>
        </el-form-item>
        <el-form-item prop="contact">
          <div class="form_title">联系方式</div>
          <el-input
            v-model.trim="feedbackForm.contact"
            placeholder="请输入联系方式"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="fb_footer">
        <el-button
          class="submit_btn ta3"
          :loading="fbBtnLoading"
          @click="feedbackSubmit('fbRef')"
          >立即提交</el-button
        >
      </span>
    </el-dialog>
  </footer>
</template>
<script>
import { getToken } from "@/utils/auth";
import { feedback } from "@/api/comment.js";
import { mapGetters } from "vuex";
export default {
  name: "commonFooter",
  props: {
    isFixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      feedbackVisible: false,
      feedbackForm: {
        type: 1, // 类型: 1-故障 0-建议 2-投诉
        contents: "", // 反馈内容
        contact: "", // 联系方式
      },
      rules: {
        contents: [
          { required: true, message: "请输入反馈内容", trigger: "change" },
        ],
        contact: [
          { required: true, message: "请输入联系方式", trigger: "change" },
        ],
      },
      fbBtnLoading: false, // 提交加载
      feedbackType: [
        { name: "故障", id: 1 },
        { name: "建议", id: 0 },
        { name: "投诉", id: 2 },
      ],
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      // console.log('Dom更新后,再执行该回调');
      //设置页面主体元素最小高度：防止页面数据加载时页脚紧贴页脚
      this.setMainMinHeight();
      window.addEventListener(
        "resize",
        () => {
          this.setMainMinHeight();
        },
        false
      );
    });
  },
  methods: {
    setMainMinHeight() {
      // let root = document.documentElement || document.body,
      //   main = document.querySelector(".main");
      // let winH = root.clientHeight,
      //   headerH = document.querySelector(".header").scrollHeight,
      //   footerH = document.querySelector(".footer").scrollHeight;
      // if (main) {
      //   let mainCssStyle =
      //     window.getComputedStyle(main, null) || main.currentStyle;
      //   let mainPadTop = mainCssStyle.paddingTop,
      //     mainPadBot = mainCssStyle.paddingBottom,
      //     mainPad = parseInt(mainPadTop) + parseInt(mainPadBot);
      //   main.style.minHeight = winH - footerH - mainPad + "px";
      // }
    },
    compHref(val) {
      if (val.indexOf("http") != -1) {
        return val;
      } else {
        return "https://" + val;
      }
    },
    // 前往后台
    toManageAdmin() {
      let href = location.href;
      let hrefHost = href.split("/")[0];
      window.open(hrefHost + "/admin/");
    },

    openFeedback() {
      if (getToken()) {
        this.feedbackVisible = true;
      } else {
        this.$message({
          message: "请先登录",
          type: "warning",
        });
      }
    },
    selectFeedbackType(val) {
      this.feedbackForm.type = val;
    },
    feedbackSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fbBtnLoading = true;
          feedback(this.feedbackForm).then((res) => {
            if (res.status) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.feedbackClose();
            } else {
              this.$message({
                message: res.msg,
                type: "error",
              });
            }
            this.fbBtnLoading = false;
          });
        } else {
          this.fbBtnLoading = false;
        }
      });
    },
    feedbackClose() {
      this.$refs.fbRef.resetFields();
      this.feedbackVisible = false;
    },
  },
  computed: {
    ...mapGetters(["website", "orgData", "identity_type"]),
  },
};
</script>
<style lang="scss" scoped>
.footer_fixed {
  position: fixed;
  bottom: 0;
  z-index: 9999;
}
.footer {
  min-height: 76px;
  background-color: var(--bg_color);
  color: #999;
  font-size: 12px;
  width: 100%;
  .h100 {
    height: 100%;
  }
  .container {
    height: 100%;
  }

  .logo {
    display: inline-block;
    width: 122px;
    height: 20px;
    margin-right: 10px;
    img {
      width: 100%;
    }
  }
  .footer_main {
    display: flex;
    align-items: center;
    gap: 8px;
    .fb_btn {
      cursor: pointer;
      font-size: 13px;
      color: #999;
      &:hover {
        color: #fff;
      }
    }
  }
  .info {
    padding-top: 11px;
  }
  .copyright {
    padding: 15px 0;
    line-height: 13px;
    text-align: center;
    font-size: 13px;
    color: #999999;
  }
  .records {
    font-size: 0;
    span {
      font-size: 12px;
      &:nth-of-type(2) {
        margin: 0 20px;
      }
      &:hover {
        color: #fff;
      }
    }
  }
  .footerNav {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 15px;
    .fnavItem {
      padding: 0px 20px;
      border-left: 1px solid #999999;
      max-width: 200px;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 13px;
      line-height: 13px;
      a,
      span {
        height: 14px;
        line-height: 14px;
        color: #999;
      }
      &:first-child {
        border: none;
      }
    }
  }
  .supor {
    padding-bottom: 15px;
    display: flex;
    justify-content: center;
    font-size: 13px;
    img {
      display: block;
    }
    .btn {
      // margin-left: 20px;
      // padding-left: 20px;
      // border-left: 1px solid #999999;
      max-width: 200px;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 13px;
      span {
        cursor: pointer;
      }
    }
  }
}
.fb_dialog {
  /deep/ .el-dialog {
    width: 400px !important;
    overflow: visible !important;
    padding: 30px;
    border-radius: 10px;
    .el-dialog__header {
      padding: 0;
      .el-dialog__headerbtn {
        top: -62px;
        right: -62px;
        width: 32px;
        height: 32px;
        margin-left: 10px;
        background: url("../assets/image/close.png") 50% 50%/100% 100% no-repeat;
        transition: all 0.3s;

        i {
          display: none;
        }

        &:hover {
          transform: scale(1.25);
        }
      }
      &::after {
        display: none;
      }
    }

    .el-dialog__body {
      padding: 0;
      .el-form {
        .el-form-item {
          margin-bottom: 20px;

          .form_title {
            font-size: 14px;
            color: #aaa;
            line-height: 18px;
            margin-bottom: 10px;
          }

          .fb_type {
            display: flex;
            gap: 14px;

            .fb_type_item {
              width: 104px;
              height: 30px;
              background: #f3f3f3;
              border-radius: 4px;
              font-size: 14px;
              color: #333;
              text-align: center;
              line-height: 30px;
              cursor: pointer;
              border: 1px solid transparent;

              &:hover {
                border-color: #66f;
              }
            }

            .active {
              background: #66f;
              color: #fff;
            }
          }

          .el-textarea {
            border: 1px solid transparent;
            border-radius: 6px;
            transition: all 0.3s;
            overflow: hidden;

            &:focus-within {
              border-color: #66f;
            }

            .el-textarea__inner {
              border: none;
              background: #f5f5f5;

              &::-webkit-scrollbar-thumb {
                /*滚动条里面小方块*/
                background: #aaf;
              }

              &::placeholder {
                color: #888;
              }
            }
          }

          .el-input {
            .el-input__inner {
              border-color: transparent;
              background: #f5f5f5;

              &:focus {
                border-color: #66f;
              }

              &::placeholder {
                color: #888;
              }
            }
          }
        }
      }
    }
    .el-dialog__footer {
      padding: 0;
      .fb_footer {
        text-align: center;

        .submit_btn {
          padding: 0;
          width: 100%;
          height: 44px;
          border-radius: 8px;
          background: #66f;
          color: #fff;
          font-size: 14px;
          text-align: center;
          line-height: 44px;
          cursor: pointer;

          &:hover {
            background: #aaf;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue